angular.module(["ng"]).run(["$templateCache", function (c) {
    c.put("pagination-template.html", "<div class=\"pagination-wrapper\"> <ul class=\"pagination pagination-sm custom-pagination\"> <li ng-class=\"{disabled: cPage==1}\"> <a href=\"javascript:void(0)\" ng-click=\"goTo(cPage-1)\" class=\"previous-page\"> <i class=\"entypo-chevron-left\"></i> </a> </li> <li ng-repeat=\"n in getPages() track by $index\" ng-class=\"{active: n == cPage, 'no-ev': n=='...'}\"> <a href=\"javascript:void(0)\" ng-bind=\"n\" ng-click=\"goTo(n)\"></a> </li> <li ng-class=\"{disabled: cPage==getMax()}\"> <a href=\"javascript:void(0)\" ng-click=\"goTo(cPage+1)\" class=\"next-page\"> <i class=\"entypo-chevron-right\"></i> </a> </li> </ul> </div>");
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/pagination-template.html
 ** module id = 170
 ** module chunks = 0
 **/